export const HELIX_TYPE_LIST = 'list';

export function findAncestorWithHelixType(element, helixType) {
    if (!element || !helixType) {
        return null;
    }

    let parent = element;
    while (parent && parent.getAttribute('data-helix-type') !== helixType) {
        parent = parent.parentElement;
    }

    return parent;
}
